export function parseFilter(filter?: string) {
  if (!filter) return {};

  try {
    return JSON.parse(filter);
  } catch (e) {
    return {};
  }
}
